import { useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { Footer } from './Footer';
import { Breadcrumbs } from './Breadcrumbs';
import { useState } from 'react';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const isEditorPage = location.pathname.includes('/editor');
  const isLoginPage = location.pathname === '/login';
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      <div className="flex flex-1 pt-16">
        {!isEditorPage && !isLoginPage && (
          <Sidebar 
            isCollapsed={isSidebarCollapsed} 
            onCollapse={setIsSidebarCollapsed} 
          />
        )}
        <div 
          className={`flex-1 flex flex-col transition-all duration-300 ${
            !isEditorPage && !isLoginPage 
              ? isSidebarCollapsed 
                ? 'lg:pl-16' 
                : 'lg:pl-64'
              : ''
          }`}
        >
          {!isLoginPage && <Breadcrumbs />}
          <main className="flex-1 p-6">
            {children}
          </main>
          <Footer />
        </div>
      </div>
    </div>
  );
}